module.exports = __webpack_public_path__ + "static/media/flag-af.2962aad5.webp";